<template>
  <el-dialog
    :title="$t('SmartLocker.DetailDialogTitle')"
    :visible="isDialogVisible"
    class="detail-dialog"
    :show-close="true"
    @close="closeDialog"
    width="55%"
  >
    <el-tabs id="smartLockerDetailTab" v-model="activeName">
      <el-tab-pane name="record">
        <span slot="label">{{ $t('SmartLocker.DetailDialogLabel') }}</span>
        <div class="title-bar" :class="statusInfo.statusLevel">
          <div>{{ statusInfo.scheduleName }}</div>
        </div>
        <div class="record">
          <div v-for="(item, index) in recordList" :key="`${item.StatusName}_${index}`" class="history-node">
            <div class="node-point-group">
              <div
                class="node-point"
                :class="index + 1 !== recordList.length ? 'not-last' : item.statusLevel"
              >
                <div
                  v-if="index + 1 === recordList.length"
                  class="node-circle"
                />
              </div>
              <div
                v-if="index + 1 !== recordList.length"
                class="node-line"
                :class="index + 2 === recordList.length ? recordList[index + 1].statusLevel : ''"
              />
            </div>
            <div class="node-content" :class="index + 1 !== recordList.length ? 'not-last' : item.statusLevel">
              <div>
                <div class="node-name">{{ item.scheduleName }}</div>
                <div v-if="item.Note" class="node-note">{{ item.Note }}</div>
              </div>
              <div class="node-time">{{ $newFormatDate(item.CreatedAt, 'yyyy-MM-dd HH:mm') }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import { apiSmartLocker } from '@/api/SmartLocker.js'
export default {
  props: {
    postalDetailId: String
  },
  data () {
    return {
      isDialogVisible: false,
      activeName: 'record',
      statusMap: {
        1: {
          statusLevel: 'normal',
          scheduleName: this.$t('SmartLocker.ScheduleName1')
        },
        2: {
          statusLevel: 'normal',
          scheduleName: this.$t('SmartLocker.ScheduleName2')
        },
        3: {
          statusLevel: 'error',
          scheduleName: this.$t('SmartLocker.ScheduleName3')
        },
        4: {
          statusLevel: 'normal',
          scheduleName: this.$t('SmartLocker.ScheduleName4')
        },
        5: {
          statusLevel: 'warning',
          scheduleName: this.$t('SmartLocker.ScheduleName5')
        },
        6: {
          statusLevel: 'normal',
          scheduleName: this.$t('SmartLocker.ScheduleName6')
        },
        7: {
          statusLevel: 'error',
          scheduleName: this.$t('SmartLocker.ScheduleName7')
        },
        8: {
          statusLevel: 'warning',
          scheduleName: this.$t('SmartLocker.ScheduleName8')
        }
      },
      nowStatus: null,
      recordList: []
    }
  },
  computed: {
    statusInfo () {
      return this.statusMap[this.nowStatus] || {}
    }
  },
  watch: {
    postalDetailId () {
      if (!this.postalDetailId) this.recordList = []
      else this.getRecordList()
    }
  },
  methods: {
    openDialog () {
      this.isDialogVisible = true
    },
    closeDialog () {
      this.isDialogVisible = false
    },
    async getRecordList () {
      try {
        const query = {
          PostalDetailId: this.postalDetailId
        }
        const res = await apiSmartLocker.GetApplyStorageRecord(query)
        if (res?.data?.Data) {
          this.recordList = res.data.Data.ApplyStorageRecordList.map((item) => {
            item.statusLevel = this.statusMap[item.StatusId]?.statusLevel || 'normal'
            item.scheduleName = this.statusMap[item.StatusId]?.scheduleName || ''
            return item
          })
          this.nowStatus = this.recordList[this.recordList.length - 1].StatusId
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-dialog {
  ::v-deep .el-dialog {
    @include basicDialog;
    text-align: left;
    .title {
      margin-bottom: 16px;
    }
    .cancel-reason-type-select {
      margin-bottom: 24px;
    }
    .cancel-reason-info {
      margin-bottom: 32px;
    }
    .footer {
      text-align: center;
    }
  }
  #smartLockerDetailTab {
    text-align: center;
    ::v-deep .el-tabs {
      @include basicTabs;
      &__header {
        margin: 0 0 0;
      }
      &__item {
        min-width: 130px;
        height: 42px;
        span {
          width: 100%;
          display: inline-block;
        }
      }
      &__content {
        padding: 16px;
      }
    }
  }
  .title-bar {
    padding: 24px 16px;
    border-radius: 4px;
    text-align: left;
    font-size: map-get($fontSize, large);
    font-weight: bold;
    margin-bottom: 28px;
    &.normal {
      background-color: $bgPrimary;
      color: $mainColor;
    }
    &.error {
      background-color: $bgOrange;
      color: $dangerColor;
    }
    &.warning {
      background-color: $bgWarning;
      color: $orangeFontColor;
    }
  }
  .record {
    .history-node {
      display: flex;
      margin-bottom: 4px;
      .node-point-group {
        text-align: center;
        .node-point {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 15px;
          width: 15px;
          border: 2px solid $mainColor;
          border-radius: 100%;
          &.warning {
            border-color: $orangeFontColor;
            .node-circle {
              background-color: $orangeFontColor;
            }
          }
          .node-circle {
            width: 9px;
            height: 9px;
            border-radius: 100%;
            background-color: $mainColor;
          }
        }
        .node-line {
          height: calc(100% - 16px);
          min-height: 50px;
          margin-left: 8px;
          border-left: 2px dashed $mainColor;
          &.warning {
            border-color: $orangeFontColor;
          }
        }
      }
      .node-content {
        margin-left: 12px;
        text-align: left;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: start;
        &.not-last {
          color: $mainFontColor !important;
        }
        &.normal {
          color: $mainColor;
        }
        &.warning {
          color: $orangeFontColor;
        }
        .node-name {
          font-size: map-get($fontSize, small);
          font-weight: bold;
        }
        .node-note {
          font-size: map-get($fontSize, small);
          margin-top: 4px;
          color: $subFontColor;
        }
        .node-time {
          font-size: map-get($fontSize, small);
          color: $subFontColor;
        }
      }
    }
  }
}
</style>
